export const handleChange = (value, setValue) => {
    let formattedDate = value?.format("YYYY/MM/DD");
    formattedDate = formattedDate.replace(/\//g, "-");
    const persianToEnglish = (str) => str.replace(/[۰-۹]/g, (char) => String.fromCharCode(char.charCodeAt(0) - 1728));
    const finalDate = persianToEnglish(formattedDate);
    setValue(finalDate);
}